import script from "./CareersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CareersPage.vue?vue&type=script&setup=true&lang=js"

import "./CareersPage.vue?vue&type=style&index=0&id=c9a82526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9a82526"]])

export default __exports__